type AppEnvironment = 'development' | 'production' | 'staging' | 'uat'

interface RuntimeConfig {
    API_URL?: string
    MINIO_URL?: string
    APP_ENV?: AppEnvironment
    DEBUG?: string
    VITE_AUTH_API_URL?: string
    VITE_API_BASE_URL?: string
    VITE_APP_ENV?: AppEnvironment
    VITE_DEBUG?: string
}

interface Env {
    readonly VITE_AUTH_API_URL: string
    readonly VITE_API_BASE_URL: string
    readonly VITE_APP_ENV: AppEnvironment
    readonly VITE_DEBUG?: string
    readonly MINIO_URL?: string
}

declare global {
    interface Window {
        __APP_CONFIG__?: RuntimeConfig
    }
}

const runtimeConfig = (): RuntimeConfig =>
    typeof window === 'undefined' ? {} : window.__APP_CONFIG__ ?? {}

const getEnv = (): Env => {
    const runtime = runtimeConfig()
    const authApiUrl = String(runtime.API_URL ?? runtime.VITE_AUTH_API_URL ?? import.meta.env.VITE_API_URL ?? import.meta.env.VITE_AUTH_API_URL ?? '')
    const apiBaseUrl = String(runtime.VITE_API_BASE_URL ?? import.meta.env.VITE_API_BASE_URL ?? authApiUrl)

    if (!authApiUrl) {
        console.warn('Missing API_URL runtime config')
    }

    return {
        VITE_AUTH_API_URL: authApiUrl,
        VITE_API_BASE_URL: apiBaseUrl,
        VITE_APP_ENV: String(runtime.APP_ENV ?? runtime.VITE_APP_ENV ?? import.meta.env.VITE_APP_ENV ?? 'development') as AppEnvironment,
        VITE_DEBUG: String(runtime.DEBUG ?? runtime.VITE_DEBUG ?? import.meta.env.VITE_DEBUG ?? ''),
        MINIO_URL: String(runtime.MINIO_URL ?? import.meta.env.VITE_MINIO_URL ?? '')
    }
}

const env = getEnv()

export const AppConfig = {
    ...env,
    isDev: env.VITE_APP_ENV === 'development',
    isProd: env.VITE_APP_ENV === 'production',
    apiBase: env.VITE_AUTH_API_URL,
    subscriptionApiBase: env.VITE_API_BASE_URL
}
